type Props = {
  children: React.ReactNode
}

function HotBonusWrapper({ children }: Props) {
  return (
    <div className="flex flex-row gap-0 justify-between items-center bg-[#241800] rounded-lg p-4">
      <div className="flex flex-col">
        <div className="text-[13px] leading-[21px] font-semibold text-[#E3E3E3]">
          OKAMŽITÝ BONUS
        </div>
        <div className="text-[10px] leading-[10px] font-medium text-[#919191]">
          Tento bonus je časovo obmedzený
        </div>
      </div>
      {children}
    </div>
  )
}

export { HotBonusWrapper }
